<template>
  <div>
    <el-dialog
      title="配置"
      :visible.sync="openCardDialog"
      width="30%">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="轮播图图片" name="first">
          <el-upload
            class="upload-demo"
            action="/api/zuul/fs/files/upload"
            :on-preview="handlePreview"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :data="addFilesDate"
            :file-list="fileList"
            multiple>
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-tab-pane>
        <el-tab-pane label="区域参数" name="second">
          <el-form label-width="70px" :model="cardFrom">
            <el-form-item label="区域高度">
              <el-input size="small" v-model="cardFrom.height"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="determine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "editCarousel",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeName: 'first',
      fileList:[],
      addFilesDate:{
        'metaData.formId': 'carousel202204251523tian',
        'metaData.fileName': '轮播图',
        'metaData.fileType': 'carousel',
      },
      cardFrom:{
        height:'60%'
      }
    };
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.getFilesSearch('carousel202204251523tian')
  },
  methods:{
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    // 确定
    determine() {
      // 获取选中的数据
      this.$emit('determine',this.cardFrom)
    },
    // 获取轮播图
    getFilesSearch(row) {
      let host = window.location.host;
      this.$axios.post(`/api/fs/files/search?metaData.formId=${row}&metaData.fileType=carousel`).then(res => {
        if (res.status === 200) {
          res.data.forEach((item,index) => {
            item.name = item.filename
            item.url = `${host}/api/fs/files/view/${item.id}`
          })
          this.fileList = res.data
        }
      });
    },
    handleRemove(file, fileList) {
      this.$axios.delete('/api/fs/files/delete/'+file.id).then(res => {
        this.$message({ type: "success", message: "删除成功!" });
        this.getFilesSearch('carousel202204251523tian')
        this.$emit('getFiles')
      }).catch(error => {
        this.$message({ type: "error", message: "删除失败!" });
      })
    },
    handleSuccess(file) {
      this.$message({ type: "success", message: "上传成功!" });
      this.getFilesSearch('carousel202204251523tian')
      this.$emit('getFiles')
    },
    handlePreview(file) {
      document.location.href =`/api/fs/files/download/${file.id}?asAttachment=true`
    },
  }
}
</script>

<style scoped>
>>> .el-dialog__body {
  padding: 0 20px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/pageConfig/editCarousel.vue